// extracted by mini-css-extract-plugin
export default {"savebtnclr":"chatBuilder_savebtnclr__zn2Fj"};